const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

export const updateProfileImageMaybe = async (file, onUpdateProfile) => {
  if (file) {
    return sdk.images
      .upload(
        {
          image: file,
        },
        {
          expand: true,
        }
      )
      .then(res => {
        const imageId = res.data.data.id;
        const updatedUserProfileValues = { profileImageId: imageId };
        return onUpdateProfile(updatedUserProfileValues);
      })
      .catch(e => {
        console.log(e);
        return Promise.resolve('error on update logo');
      });
  } else {
    return Promise.resolve('no new logo provided');
  }
};
